// src/app/core/guard/role.guard.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../service/auth.service';

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  const roles = (route.data['roles'] as string[] | undefined) ?? [];
  if (roles.length === 0 || authService.hasAnyRole(roles)) {
    return true;
  }

  return authService.hydrateCurrentUser().pipe(
    map(() => authService.hasAnyRole(roles)
      ? true
      : router.createUrlTree(['/forbidden'])),
    catchError(() => of(router.createUrlTree(['/forbidden']))),
  );
};
